import { IReparcelingSimulationsRepository } from 'modules/customer/domain/repositories';
import {
  IVectisReparcelingSimulation,
  ReparcelingSimulation,
} from 'modules/customer/infra/adapters';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisReparcelingSimulationsRepository
  implements IReparcelingSimulationsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findAllByReparcelingHash: IReparcelingSimulationsRepository['findAllByReparcelingHash'] =
    async ({ hash, cash }) => {
      const { parcelamento } = await this.httpProvider.get<{
        parcelamento: IVectisReparcelingSimulation[];
      }>(`/reparcelamentoContrato/${hash}/condicoes`, {
        params: { valorEntrada: cash },
      });

      return parcelamento.map(parcela => new ReparcelingSimulation(parcela));
    };
}
